import { request } from "@/components/Joyspace/api/request";
import { SecuresTypeValEnum, SelectRoleEnum, SelectValEnum } from "@jd/focus-joyspace-comps";
// import { SelectRoleEnum } from '@jd/focus-joyspace-comps';
import { message } from "antd";

export function get(
  id?: string,
  type: "page" | "space" | "team" | "folder" | "document" = "space"
) {
  return request({
    api: "joyspace.permission.get",
    path: "v1/permissions",
    method: "POST",
    body: {
      [type + "Id"]: id
    }
  });
}

interface MembersType {
  groups: [
    {
      gid: string;
      id: string;
      name: string;
      permission_type: 0;
      share_by: string;
    }
  ];
  orgs: [
    {
      code: string;
      name: string;
      permission_type: 0;
      share_by: string;
    }
  ];
  permissionType: 0;
  total: 0;
  users: [
    {
      avatar_url: string;
      full_org_name: string;
      full_org_path: string;
      id: string;
      is_link: 0;
      mobile: string;
      name: string;
      org_code: string;
      org_name: string;
      permission_type: 0;
      position_name: string;
      share_by: string;
      tenant_id: string;
      user_id: string;
      user_type: 0;
      username: string;
    }
  ];
}

import { joyspacePermissionType } from "../config/permissions.config";
import { FileType, OpenFolderStatus, SharesMembers, ShareType } from "../types";
import { lang } from "../context";
import { createJoyspcFolderData } from "../util";
const handleData = (item: any) => {
  let defaultAvatar = "";
  if (!item.avatar_url) {
    defaultAvatar = item.name ? item.name.substring(0, 1) : item.name.substring(0, 1);
  }
  return {
    avatar: item.avatar_url || "",
    defaultAvatar,
    name: item.name,
    shareId: item.id,
    permissionType: item.permission_type,
    desc: item.position_name || "",
    orgName: item.org_name || ""
  };
};

export interface ParamesType {
  id: string;
  search?: string;
  type: FileType;
  pageIndex: number;
  pageSize: number;
}

export enum UserType {
  // All = 'All',
  // RecentlyContact = 'recentlyContact',
  Contact = "contact",
  Department = "department",
  Groups = "groups"
}
// 协作人管理
export async function getUserPermissionList(parames: ParamesType) {
  return request({
    api: "joyspace.share.members",
    path: `v1/shares/members`,
    method: "POST",
    body: {
      page_id: parames.id,
      search: parames.search || "",
      type: parames.type,
      start: parames.pageIndex || 1,
      length: parames.pageSize || 30
    }
  })
    .then((res) => {
      let groups =
        (res.groups &&
          res.groups.map((item: any) => {
            const _item: any = handleData(item);
            _item.id = item.gid;
            _item.type = UserType.Groups;
            return _item;
          })) ||
        [];
      let orgs =
        (res.orgs &&
          res.orgs.map((item: any) => {
            const _item: any = handleData(item);
            _item.id = item.code;
            _item.type = UserType.Department;
            return _item;
          })) ||
        [];
      let user =
        (res.users &&
          res.users.map((item: any) => {
            const _item: any = handleData(item);
            _item.id = item.user_id;
            _item.type = UserType.Contact;
            return _item;
          })) ||
        [];
      return groups.concat(orgs, user);
    })
    .catch(() => []);
}

interface PermissionListType {
  permission: joyspacePermissionType;
  shareId: string;
}
// 批量设置协作人管理
export function setBatchPrmission(permissionList: PermissionListType[]) {
  return request({
    api: "joyspace.share.batchSetPermission",
    path: `v1/shares/batchSetPermission`,
    method: "PUT",
    body: permissionList
  }).catch(() => false);
}
// 批量删除协作人
export function setBatchRemove(shareList: string[], pageId: any) {
  return request({
    api: "joyspace.share.batchRemoveShare",
    path: `v1/shares/batchRemoveShare`,
    method: "DELETE",
    body: {
      resourceId: pageId,
      shareIds: shareList
    }
  }).catch(() => false);
}
// 单个
export function setPrmission(shareId = "", permission = 2) {
  return request({
    api: "joyspace.share.batchPrmission",
    path: `v1/shares/${shareId}/permission`,
    method: "PUT",
    body: { permission }
  }).catch(() => false);
}
export function batchPermission(shareList: any[]) {
  return request({
    api: "joyspace.share.batchSetPermission",
    path: `v1/shares/batchSetPermission`,
    method: "PUT",
    body: shareList
  }).catch(() => false);
}
// 删除权限
export function removePrmission(shareId: string, pageId: any) {
  return request({
    api: "joyspace.share.batchRemoveShare",
    path: `v1/shares/batchRemoveShare`,
    method: "DELETE",
    body: {
      resourceId: pageId,
      shareIds: [shareId]
    }
  }).catch(() => false);
}

// shares/members
// 分享和添加权限管理
// 删除权限
export interface GroupsParamesType {
  gid: string;
  permission_type: number | string;
}
export interface OrgsParamesType {
  code: string;
  permission_type: number | string;
}
export interface UserParamesType {
  id: string;
  permission_type: number | string;
}
export interface AddMembersParamesType {
  id: string;
  type: FileType;
  dialogueMessage?: ShareType;
  toGroups: GroupsParamesType[];
  toOrgs: OrgsParamesType[];
  toUsers: UserParamesType[];
  toEpssUsers: any;
}
export function addMembers(parames: AddMembersParamesType) {
  return request({
    api: "joyspace.share.create",
    path: `v1/shares`,
    method: "POST",
    body: {
      page_id: parames.id,
      type: parames.type,
      to_groups: parames.toGroups,
      to_orgs: parames.toOrgs,
      to_eepaas_users: parames.toEpssUsers,
      to_users: parames.toUsers,
      dialogueMessage: parames.dialogueMessage || ShareType.ShareAI,
      dialogueContent: ""
    }
  })
    .then((res: any) => {
      if (res === undefined || res?.code === "10002") {
        message.error("操作失败");
        return false;
      }
      const { code, status } = res;
      if (code !== "200") {
        message.error(status);
        return false;
      }
      return true;
    })
    .catch(() => false);
}

// 设置公开文件夹
export function setOpenFolder(id: string, open: OpenFolderStatus) {
  return request({
    api: "joyspace.folder.open",
    path: `v1/folders/${id}/open?open=${open}`,
    method: "PUT"
  }).catch(() => false);
}

// 获取协同人数量
export function getShareCount(id: string) {
  return request({
    api: "joyspace.share.shareCount",
    path: `/v1/shares/${id}`,
    method: "GET"
  }).catch(() => false);
}

// 权限管理列表分组查询
export function sharesMembers(parames: SharesMembers) {
  return request({
    api: "joyspace.share.allSharesMembers",
    path: `/v1/shares/allSharesMembers`,
    method: "POST",
    body: {
      length: parames.length,
      memberType: parames.memberType,
      page_id: parames.pageId,
      search: parames.search,
      start: parames.start,
      type: parames.fileType
    }
  }).catch((err) => err);
}

// 权限管理列表分组查询
export function sharesCount(pageId = "") {
  return request({
    api: "joyspace.share.allsharesCount",
    path: `/v1/shares/${pageId}/allSharesCount`,
    method: "GET"
  }).catch(() => false);
}

// 获取登录人的对文档或文件夹的真实权限
export function getShareIdByPermissionType(shareId = "") {
  return request({
    api: "joyspace.share.permissionType",
    path: `/v1/shares/${shareId}/permissionType`,
    method: "GET"
  }).catch(() => -99);
}

// 添加安全设置
export const addSecuritySettings = async (id = "", fileType = FileType.Page, secures: any = []) => {
  const res = await request({
    api: "joyspace.secures.add",
    path: `/v1/secures`,
    method: "POST",
    body: {
      bizId: id,
      bizType: fileType === FileType.Folder ? 2 : FileType.Page,
      secures,
      version: 2
    }
  });
  if (!Array.isArray(res)) {
    message.error(lang("common.fail"));
    return false;
  }
  message.success("设置成功");
  return res;
};
// 获取安全设置
export const getSecuritySettings = async (id = "", fileType = FileType.Page) => {
  const bizType = fileType === FileType.Folder ? 2 : FileType.Page;
  const res = await request({
    api: "joyspace.secures.list",
    path: `/v1/secures/${id}/${bizType}?version=2`,
    method: "GET"
  });
  const roleId =
    fileType === FileType.Folder
      ? String(SelectRoleEnum.FolderAll)
      : String(SelectRoleEnum.FileAll);
  if (!res.length || !res) {
    return [
      {
        bizId: id,
        bizType,
        securesType: SecuresTypeValEnum.Share,
        roleId,
        show: SelectValEnum.ALL
      },
      {
        bizId: id,
        bizType,
        securesType: SecuresTypeValEnum.Download,
        roleId,
        show: SelectValEnum.ALL
      }
    ];
  } else if (res.length === 1) {
    let tmpArr = [...res];
    res[0].permission === SecuresTypeValEnum.Share
      ? tmpArr.push({
          bizId: id,
          bizType,
          securesType: SecuresTypeValEnum.Download,
          roleId,
          show: SelectValEnum.ALL
        })
      : tmpArr.push({
          bizId: id,
          bizType,
          securesType: SecuresTypeValEnum.Share,
          roleId,
          show: SelectValEnum.ALL
        });
    return tmpArr;
  }
  return res;
};

export const addJoysapceMap = (folderId = "", info = {}, addJoysapceMap: any) => {
  const fileType = (info as any).page_type ? FileType.Page : FileType.Folder;
  if (typeof info !== "object") {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject("info  not a object");
  }
  if (!folderId) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject("id  can't null");
  }
  return new Promise((resolve, reject) => {
    request({
      api: "joyspace.folder.owner",
      path: `/v1/folders/${folderId}/owner`,
      method: "GET"
    })
      .then((res: any) => {
        let tmpInfo: any;
        if (!res) {
          tmpInfo = createJoyspcFolderData(fileType, info);
          if (tmpInfo) {
            addJoysapceMap?.([tmpInfo]);
          }
          resolve(joyspacePermissionType.ReadDel);
        } else {
          res.folderVo.title = res.folderVo.name;
          res.folderVo.isFolder = true;
          tmpInfo = { ...res.folderVo };
          addJoysapceMap?.([tmpInfo]);
          resolve(tmpInfo);
        }
      })
      .catch((err: any) => {
        console.error(err);
        // eslint-disable-next-line prefer-promise-reject-errors
        reject(err);
      });
  });
};
